import { Login } from '@src/components/Login';
import { EssentialProviders, Providers } from '@src/components/Providers';
import { AuthContextProvider, isInIFrame, PortalContextProvider } from '@talos/kyoko';
import { createBrowserRouter, Route, RouterProvider, Routes } from 'react-router-dom';

import { ErrorBoundaryRouted } from '@src/components/ErrorBoundary';
import { IFrameAuthHandler } from '@src/components/IFrameAuthHandler';
import { WLSessionExpiredModal } from '@src/components/WLSessionExpiredModal';
import { envConfig } from '@src/utils/envConfig';
import { useCallback } from 'react';
import { Layout } from './components/Layout';
import { Unauthorized } from './components/Unauthorized';

function AppInner() {
  // Use silent-login URL when in iframe and available, otherwise use regular login URL
  // This ensures backwards compatibility if VITE_AUTH_SILENT_LOGIN_URL is not configured
  const silentLoginUrl = envConfig.VITE_AUTH_SILENT_LOGIN_URL;
  const loginUrl = isInIFrame() && silentLoginUrl ? silentLoginUrl : envConfig.VITE_AUTH_LOGIN_URL;
  const onReload = useCallback(() => window.location.reload(), []);
  const onIsInIFrame = useCallback(() => isInIFrame(), []);

  return (
    <PortalContextProvider>
      <IFrameAuthHandler onReload={onReload} isInIFrame={onIsInIFrame}>
        <AuthContextProvider
          loginUrl={loginUrl}
          logoutUrl={envConfig.VITE_AUTH_LOGOUT_URL}
          sessionCookieName={envConfig.VITE_SESSION_COOKIE}
        >
          <EssentialProviders>
            <Routes>
              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/*"
                element={
                  <Providers>
                    <WLSessionExpiredModal />
                    <Layout />
                  </Providers>
                }
              />
            </Routes>
          </EssentialProviders>
        </AuthContextProvider>
      </IFrameAuthHandler>
    </PortalContextProvider>
  );
}

const browserRouter = createBrowserRouter([
  { path: '*', element: <AppInner />, errorElement: <ErrorBoundaryRouted /> },
]);

export const App = () => {
  return <RouterProvider router={browserRouter} />;
};

export default App;
